// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"1061":"291c8fdd03e887ae4a86","4656":"9cee232f77c37986ea17","5764":"6902df081123b16531e2"}[chunkId] + ".js";
};